/**
 * Weights come off EBMS as floats, so sums print artifacts like
 * `382.20000000000005`. One decimal is all packaging needs; trailing `.0` drops.
 */
export function formatWeight(value: number | null | undefined): string | null {
  if (value == null || !Number.isFinite(value)) return null
  return String(Math.round(value * 10) / 10)
}
